export default "/images/vendor/flag-icons/flags/1x1/uy.svg?cb5fcc05a537d0236c3cb190b6c75abc";